import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableFallbackReviewTerms = loadable(
  () => import('./FallbackReviewTerms'),
  { fallback: <LoadingScreen /> },
);

export default LoadableFallbackReviewTerms;
